import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useLocation } from "react-router-dom";

import zipzyAdminApiClient from "../apiClients/zipzyAdminApiClient";

export default function Navbar() {
  const isLoggedIn = zipzyAdminApiClient.isLoggedIn();

  const navigate = useNavigate();

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <AppBar position="static" color="primary" elevation={2} sx={{ mb: 3.5 }}>
      <Toolbar
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
          }}
        >
          Zipzy Admin
        </Typography>

        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
          {currentPath !== "/" && (
            <IconButton color="inherit" onClick={() => navigate("/")}>
              <HomeIcon />
            </IconButton>
          )}

          {currentPath !== "/db/users/add" && (
            <IconButton color="inherit" onClick={() => navigate("/db/users/add")}>
              <PersonIcon />
            </IconButton>
          )}

          {currentPath !== "/analytics/drivers" && (
            <IconButton color="inherit" onClick={() => navigate("/analytics/drivers")}>
              <DriveEtaIcon />
            </IconButton>
          )}

          {currentPath !== "/analytics/rides" && (
            <IconButton color="inherit" onClick={() => navigate("/analytics/rides")}>
              <QueryStatsIcon />
            </IconButton>
          )}

          {isLoggedIn && (
            <IconButton
              color="inherit"
              onClick={async () => {
                if (!window.confirm("Are you sure you want to logout?")) {
                  return;
                }

                await zipzyAdminApiClient.logout();
                navigate("/auth/login");
              }}
            >
              <LogoutIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
